<mtg-table>
  <mtg-table-header-row mtgSticky="top" [top]="headerHeight">
    <mtg-table-identity-col></mtg-table-identity-col>
    <mtg-table-col-group title="Матчей">
      <mtg-table-col>всего</mtg-table-col>
      <mtg-table-col>выиграно</mtg-table-col>
      <mtg-table-col>проиграно</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Результаты">
      <mtg-table-col>2-0</mtg-table-col>
      <mtg-table-col>2-1</mtg-table-col>
      <mtg-table-col>1-2</mtg-table-col>
      <mtg-table-col>0-2</mtg-table-col>
      <mtg-table-col>очков</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Сеты">
      <mtg-table-col>выиграно</mtg-table-col>
      <mtg-table-col>проиграно</mtg-table-col>
      <mtg-table-col>В/П</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Очки">
      <mtg-table-col>забито</mtg-table-col>
      <mtg-table-col>пропущено</mtg-table-col>
      <mtg-table-col>З/П</mtg-table-col>
    </mtg-table-col-group>
  </mtg-table-header-row>
  <mtg-table-row *ngFor="let tournamentTeam of teams; let i = index;">
    <mtg-table-identity-col>
      <div class="number">{{ i + 1 }}</div>
      <div class="photo">
        <a
          [routerLink]="getTeamPageRoute(tournamentTeam.tournamentTeam.team.id)"
          queryParamsHandling="preserve"
        >
          <img [src]="tournamentTeam.tournamentTeam.logo.path"
               *ngIf="tournamentTeam.tournamentTeam.logo.path"
               [alt]="tournamentTeam.tournamentTeam.name"
          />
          <div [class]="tournamentTeam.tournamentTeam.team.getEmptyLogoClass()" *ngIf="!tournamentTeam.tournamentTeam.logo.path"></div>
        </a>
      </div>
      <div class="info">
        <div class="name">
          <a
            [routerLink]="getTeamPageRoute(tournamentTeam.tournamentTeam.team.id)"
            queryParamsHandling="preserve"
          >{{ tournamentTeam.tournamentTeam.name }}</a>
        </div>
      </div>
    </mtg-table-identity-col>
    <mtg-table-col-group>
      <mtg-table-col>{{ tournamentTeam.gamesCount }}</mtg-table-col>
      <mtg-table-col>{{ tournamentTeam.wonGamesCount }}</mtg-table-col>
      <mtg-table-col>{{ tournamentTeam.gamesCount - tournamentTeam.wonGamesCount }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ getGamesCount(tournamentTeam, 2, 0) }}</mtg-table-col>
      <mtg-table-col>{{ getGamesCount(tournamentTeam, 2, 1) }}</mtg-table-col>
      <mtg-table-col>{{ getGamesCount(tournamentTeam, 1, 2) }}</mtg-table-col>
      <mtg-table-col>{{ getGamesCount(tournamentTeam, 0, 2) }}</mtg-table-col>
      <mtg-table-col>{{ tournamentTeam.points || 0 }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ tournamentTeam.scoreSum }}</mtg-table-col>
      <mtg-table-col>{{ tournamentTeam.missedSum }}</mtg-table-col>
      <mtg-table-col>{{ getRatio(tournamentTeam.scoreSum, tournamentTeam.missedSum) }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ tournamentTeam.scorePointsSum }}</mtg-table-col>
      <mtg-table-col>{{ tournamentTeam.missedPointsSum }}</mtg-table-col>
      <mtg-table-col>{{ getRatio(tournamentTeam.scorePointsSum, tournamentTeam.missedPointsSum) }}</mtg-table-col>
    </mtg-table-col-group>
  </mtg-table-row>
</mtg-table>
